var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"modern-scrollbar"},[_c('v-main',[_c('router-view'),_c('snt-overlay-loading',{attrs:{"loading":_vm.isLoading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }